/*
 * @Author: zhaozhuo
 * @Date: 2022-02-18 10:58:51
 * @LastEditors: zhangquanming 419654548@qq.com
 * @LastEditTime: 2023-09-25 17:11:40
 * @Description: file content
 * @FilePath: \edc-mobile-web\src\request\api\subject.js
 */
import { post, get } from '../axios'
const subject = {
  // 获取患者
  getSubject: (params) => get(`/web/subject/getSubjectEditInfo/${params}`),
  // 添加患者
  addSubject: (params) => post('/web/subject/saveReceptor', params),
  addDonator: (params) => post('/web/subject/saveDonator', params),
  // 更新受试者
  updateSubject: (params) => post('/web/subject/updateSubject', params),
  // 删除患者
  delSubject: (params, items) =>
    post(`/web/subject/deleteSubject/${params}`, items),
  // 患者列表
  getSubjectList: (params) => post('/web/subject/getSubjectInfoList', params),
  // 获取患者添加配置
  getSubjectAddedInfo: (params) =>
    get(`/web/subject/getSubjectAddedInfo/${params}`),
  // 获取受试者组列表
  getSubjectGroupList: (params) =>
    get(`/web/subjectGroup/getSubjectGroupList/${params}`),
  // 添加患者组
  addSubjectGroup: (params) =>
    post('/web/subjectGroup/saveSubjectGroup', params),
  // 删除患者组
  delSubjectGroup: (params) =>
    post(`/web/subjectGroup/deleteSubjectGroup/${params}`),
  // 更新通用访视状态为进行中
  updateSubjectProcessing: (params, items) =>
    post(
      `/web/subjectVisit/updateUniversalVisitStatusToProcessing/${params}`,
      items
    ),
  // 更新实际访视时间
  updateSubjectActualTime: (params) =>
    post('/web/subjectVisit/updateActualTime', params),
  // 添加通用实际访视时间
  updateUniversalVisitTime: (params) =>
    post('/web/subjectVisit/updateUniversalVisitTime', params),
  // 根据住院号回填患者信息
  getSubjectMgsByInpatientNumber: (params) =>
    post(`/web/subject/getSubjectMgsByInpatientNumber`, params)
}
export default subject
